export const PLACEHOLDER = {
  orders: [
    {
      id: '',
      packings: [
        {
          num: 1,
          barcode: '',
          items: [
            {
              num: 1,
              variantId: '',
              quantity: 1,
            },
            {
              num: 1,
              variantId: '',
              quantity: 1,
            },
          ],
          measurements: {
            weight: 1,
            dimensions: {
              height: 1,
              width: 1,
              depth: 1,
            },
          },
        },
      ],
    },
  ],
};

export const MOCK_DATA = {
  orders: [
    {
      date: '2023-09-26 13:40:13',
      externalId: '60-72',
      id: '60-72',
      items: [
        {
          article: '',
          barcode: '2000916300001',
          img: 'https://storage.yandexcloud.net/images-k2c/ea62ff54-ea8f-4a4c-a100-ff3ae38937ca.png',
          itemAmountState: {},
          itemDimensions: {
            depth: 1,
            height: 15,
            width: 5,
          },
          itemWeight: 80,
          name: 'Расческа в чехле Bro Cosmetics, Цвет: коричневый ',
          num: 1,
          price: 2846.0,
          productExtId: 'BR00T-000140',
          productId: '1013',
          productVariantCount: 3,
          quantity: 2,
          skuType: 'SKU',
          variantExtId: 'BR00T-000140-2',
          variantId: '154',
          vatRate: 'NO_VAT',
          vatSkuProduct: 'NO_VAT',
        },
        {
          article: '100-201-артикул',
          barcode: '100-100-201',
          itemAmountState: {},
          itemDimensions: {
            depth: 10,
            height: 10,
            width: 10,
          },
          itemWeight: 500,
          name: 'Тест товар - 100-201',
          num: 2,
          price: 1000.0,
          productId: '1066',
          productVariantCount: 1,
          quantity: 2,
          skuType: 'SKU',
          variantId: '100-201',
          vatRate: 'VAT_20',
        },
        {
          article: '',
          barcode: '',
          name: 'Доставка',
          num: 3,
          price: 0.0,
          quantity: 1,
          skuType: 'SERVICE',
          variantId: 'delivery',
          vatRate: 'NO_VAT',
        },
      ],
      notPackedItems: [
        {
          article: 'loz',
          barcode: '70100401010204111',
          img: 'https://storage.yandexcloud.net/images-k2c/f6299c22-4d07-4cb2-bcbc-6733612024bf.jpg',
          itemAmountState: {
            amountDELIVERED: 0,
            amountLOST: 0,
            amountORDERED: 3,
            amountPACKED: 0,
            amountRESERVED: 3,
            amountRETURNED: 0,
            amountRETURNED_AS_CLAIMS: 0,
            amountRETURNED_DEFECTIVE: 0,
            amountRETURNED_TO_CLIENT: 0,
            amountSHIPPED: 0,
          },
          itemDimensions: {
            depth: 1,
            height: 1,
            width: 1,
          },
          itemWeight: 100,
          name: 'Купальный костюм раздельный, цвет: 1035, размер: 3-в, женский, летний, еще какие-нибудь характеристики',
          num: 1,
          price: 2990,
          productId: '1015',
          productVariantCount: 1,
          quantity: 3,
          quantityAvailable: 999999665,
          skuType: 'SKU',
          variantExtId: '',
          variantId: '1042',
          vatRate: 'VAT_20',
          vatSkuProduct: 'VAT_20',
        },
        {
          article: 'loz',
          barcode: '70100401010204111',
          img: 'https://storage.yandexcloud.net/images-k2c/f6299c22-4d07-4cb2-bcbc-6733612024bf.jpg',
          itemAmountState: {
            amountDELIVERED: 0,
            amountLOST: 0,
            amountORDERED: 3,
            amountPACKED: 0,
            amountRESERVED: 3,
            amountRETURNED: 0,
            amountRETURNED_AS_CLAIMS: 0,
            amountRETURNED_DEFECTIVE: 0,
            amountRETURNED_TO_CLIENT: 0,
            amountSHIPPED: 0,
          },
          itemDimensions: {
            depth: 1,
            height: 1,
            width: 1,
          },
          itemWeight: 100,
          name: 'Ложка',
          num: 1,
          price: 2990,
          productId: '1015',
          productVariantCount: 1,
          quantity: 3,
          quantityAvailable: 999999665,
          skuType: 'SKU',
          variantExtId: '',
          variantId: '1042',
          vatRate: 'VAT_20',
          vatSkuProduct: 'VAT_20',
        },
      ],
      packings: [
        {
          barcode: '3837100281759',
          files: [],
          items: [
            {
              accountingAttributes: [],
              article: '',
              barcode: '2000916300001',
              img: 'https://storage.yandexcloud.net/images-k2c/ea62ff54-ea8f-4a4c-a100-ff3ae38937ca.png',
              itemDimensions: {
                depth: 1,
                height: 15,
                width: 5,
              },
              itemWeight: 80,
              name: 'Расческа в чехле Bro Cosmetics, Цвет: коричневый ',
              num: 1,
              price: 2846.0,
              productExtId: 'BR00T-000140',
              productId: '1013',
              productVariantCount: 3,
              quantity: 1,
              skuType: 'SKU',
              variantExtId: 'BR00T-000140-2',
              variantId: '154',
              vatRate: 'NO_VAT',
              vatSkuProduct: 'NO_VAT',
            },
            {
              accountingAttributes: [],
              article: '100-201-артикул',
              barcode: '100-100-201',
              itemDimensions: {
                depth: 10,
                height: 10,
                width: 10,
              },
              itemWeight: 500,
              name: 'Тест товар - 100-201',
              num: 2,
              price: 1000.0,
              productId: '1066',
              productVariantCount: 1,
              quantity: 1,
              skuType: 'SKU',
              variantId: '100-201',
              vatRate: 'VAT_20',
            },
          ],
          measurements: {
            dimensions: {
              depth: 13,
              height: 10,
              width: 11,
            },
            success: true,
            weight: 565,
          },
          num: 1,
        },
      ],
      status: 'ORDER_INFO_READY_TO_PACK',
    },
  ],
  recordsTotal: 1,
  success: true,
};

export const PACKING_MOCK_DATA = {
  orders: [
    {
      date: '2023-09-26 13:40:13',
      externalId: '60-72',
      id: '60-72',
      items: [
        {
          article: '',
          barcode: '2000916300001',
          img: 'https://storage.yandexcloud.net/images-k2c/ea62ff54-ea8f-4a4c-a100-ff3ae38937ca.png',
          itemAmountState: {},
          itemDimensions: {
            depth: 1,
            height: 15,
            width: 5,
          },
          itemWeight: 80,
          name: 'Расческа в чехле Bro Cosmetics, Цвет: коричневый ',
          num: 1,
          price: 2846.0,
          productExtId: 'BR00T-000140',
          productId: '1013',
          productVariantCount: 3,
          quantity: 2,
          skuType: 'SKU',
          variantExtId: 'BR00T-000140-2',
          variantId: '154',
          vatRate: 'NO_VAT',
          vatSkuProduct: 'NO_VAT',
        },
        {
          article: '100-201-артикул',
          barcode: '100-100-201',
          itemAmountState: {},
          itemDimensions: {
            depth: 10,
            height: 10,
            width: 10,
          },
          itemWeight: 500,
          name: 'Тест товар - 100-201',
          num: 2,
          price: 1000.0,
          productId: '1066',
          productVariantCount: 1,
          quantity: 2,
          skuType: 'SKU',
          variantId: '100-201',
          vatRate: 'VAT_20',
        },
        {
          article: '',
          barcode: '',
          name: 'Доставка',
          num: 3,
          price: 0.0,
          quantity: 1,
          skuType: 'SERVICE',
          variantId: 'delivery',
          vatRate: 'NO_VAT',
        },
      ],
      notPackedItems: [
        {
          article: '100-201-артикул',
          barcode: '100-100-201',
          itemDimensions: {
            depth: 10,
            height: 10,
            width: 10,
          },
          itemWeight: 500,
          name: 'Тест товар - 100-201',
          num: 2,
          productId: '1066',
          quantity: 1,
          skuType: 'SKU',
          variantId: '100-201',
        },
        {
          article: '',
          barcode: '2000916300001',
          img: 'https://storage.yandexcloud.net/images-k2c/ea62ff54-ea8f-4a4c-a100-ff3ae38937ca.png',
          itemDimensions: {
            depth: 1,
            height: 15,
            width: 5,
          },
          itemWeight: 80,
          name: 'Расческа в чехле Bro Cosmetics, Цвет: коричневый ',
          num: 1,
          productExtId: 'BR00T-000140',
          productId: '1013',
          quantity: 1,
          skuType: 'SKU',
          variantExtId: 'BR00T-000140-2',
          variantId: '154',
        },
      ],
      packings: [
        {
          barcode: '3837100281759',
          files: [],
          items: [
            {
              accountingAttributes: [],
              article: '',
              barcode: '2000916300001',
              img: 'https://storage.yandexcloud.net/images-k2c/ea62ff54-ea8f-4a4c-a100-ff3ae38937ca.png',
              itemDimensions: {
                depth: 1,
                height: 15,
                width: 5,
              },
              itemWeight: 80,
              name: 'Расческа в чехле Bro Cosmetics, Цвет: коричневый ',
              num: 1,
              price: 2846.0,
              productExtId: 'BR00T-000140',
              productId: '1013',
              productVariantCount: 3,
              quantity: 1,
              skuType: 'SKU',
              variantExtId: 'BR00T-000140-2',
              variantId: '154',
              vatRate: 'NO_VAT',
              vatSkuProduct: 'NO_VAT',
            },
            {
              accountingAttributes: [],
              article: '100-201-артикул',
              barcode: '100-100-201',
              itemDimensions: {
                depth: 10,
                height: 10,
                width: 10,
              },
              itemWeight: 500,
              name: 'Тест товар - 100-201',
              num: 2,
              price: 1000.0,
              productId: '1066',
              productVariantCount: 1,
              quantity: 1,
              skuType: 'SKU',
              variantId: '100-201',
              vatRate: 'VAT_20',
            },
          ],
          measurements: {
            dimensions: {
              depth: 13,
              height: 10,
              width: 11,
            },
            success: true,
            weight: 565,
          },
          num: 1,
        },
      ],
      status: 'ORDER_INFO_READY_TO_PACK',
    },
  ],
  recordsTotal: 1,
  success: true,
};
